import { render } from "./EasyConfig.vue?vue&type=template&id=b6f8442e&scoped=true"
import script from "./EasyConfig.vue?vue&type=script&lang=js"
export * from "./EasyConfig.vue?vue&type=script&lang=js"

import "./EasyConfig.vue?vue&type=style&index=0&id=b6f8442e&scoped=true&lang=css"

import exportComponent from "/home/james/WebstormProjects/pvpconfigui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6f8442e"]])

export default __exports__